@use "/app/src/scss/settings.scss"
@use "/app/node_modules/vuetify/lib/components/VLabel/VLabel.sass"
